import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import KanbanCard from "./KanbanCard";

const useStyles = makeStyles((theme) => ({
  column: {
    flex: "0 0 280px",
    minWidth: 280,
    maxWidth: 340,
    display: "flex",
    flexDirection: "column",
    borderRadius: 10,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  columnHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 14px",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  columnTitle: {
    fontWeight: 700,
    fontSize: 13,
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },
  columnBody: {
    flex: 1,
    padding: 8,
    overflowY: "auto",
    minHeight: 100,
    maxHeight: "calc(100vh - 200px)",
    ...theme.scrollbarStyles,
  },
  over: {
    backgroundColor: "rgba(243, 112, 33, 0.06)",
  },
  empty: {
    textAlign: "center",
    padding: "24px 8px",
    color: theme.palette.text.secondary,
    fontSize: 12,
  },
}));

const KanbanColumn = ({ id, title, color, tickets, readOnly }) => {
  const classes = useStyles();
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <Paper className={classes.column} variant="outlined">
      <div className={classes.columnHeader} style={{ borderTop: `3px solid ${color}` }}>
        <Typography className={classes.columnTitle} style={{ color }}>
          {title}
        </Typography>
        <Chip
          label={tickets.length}
          size="small"
          style={{
            backgroundColor: color,
            color: "#fff",
            fontWeight: 700,
            height: 20,
            fontSize: 11,
          }}
        />
      </div>
      <div
        ref={readOnly ? undefined : setNodeRef}
        className={`${classes.columnBody} ${isOver && !readOnly ? classes.over : ""}`}
      >
        {tickets.length === 0 ? (
          <Typography className={classes.empty}>Nenhum ticket</Typography>
        ) : (
          <SortableContext
            items={tickets.map((t) => t.id)}
            strategy={verticalListSortingStrategy}
          >
            {tickets.map((ticket) => (
              <KanbanCard key={ticket.id} ticket={ticket} />
            ))}
          </SortableContext>
        )}
      </div>
    </Paper>
  );
};

export default KanbanColumn;
